/**
 * 开户多语言按照页面区分
 * 内地开户以 cn 开头
 * 香港开户以 hk 开头
 * 公用页面 按照页面提取
 * 每个页面新增一个对象
 *  */
export default {
    pageTitle: '复星国际证券开户',
    复星国际证券开户: '复星国际证券开户',
    // 公共的
    backStep: '上一步',
    nextStep: '下一步',
    submit: '提交',
    input: '请输入',
    'input{0}': '请输入{0}',
    select: '请选择',
    'select{0}': '请选择{0}',
    reset: '重置',
    success: '完成',
    Understood: '已了解',
    service: '联系客服',
    confirmText: '确认无误',
    returnText: '返回修改',
    tip: '温馨提示',
    noAllowEmpty: '不能为空',
    confirm: '确认',
    determine: '确定',
    cancel: '取消',
    yes: '是',
    no: '否',
    thsTip: '您有未完成的开户流程，请使用浏览器访问以下链接继续完成开户',
    organTip: '该手机号已绑定交易账户，该类型账户即将开放线上交易功能，敬请期待！',
    know: '知道了',
    音频加载中: '音频加载中',
    音频加载失败: '音频加载失败',
    下载星财富APP: '下载星财富APP',
    ts: '提示',
    // 开户-身份证页面
    idCard: {
        title: '内地身份证验证',
        des: '身份信息仅用于开户，我们将严格保护您的个人隐私',
        positive: '点击上传 身份证人像面',
        negative: '点击上传 身份证国徽面',
        negativeMO: '点击上传 身份证区徽面',
        photoTips: {
            title: '拍照提示',
            des: '拍摄时请确保手机横向拍摄，证件边框完整、文字清晰可见、亮度均匀不反光。',
        },
        photoError: {
            standard: '标准',
            missing: '边框缺失',
            vague: '信息模糊',
            reflex: '图片反光',
        },
        chinaName: '中文姓名',
        pyName: '姓名拼音',
        idCardNumber: '身份证号码',
        address: '住宅地址',
        idAddress: '证件地址',
        signing: '签发机关',
        period: '证件有效期',
        long: '长期有效',
        birth: '出生日期',
        birthplace: '出生地点',
        addressAlikeCM: '证件地址与住宅地址、通讯地址相同',
        notAlikeAddressTip: '如证件地址与通讯地址不同，请联系客服进行线下开户。',
        max76Befor: '76岁及以上用户请',
        max76After: '进行线下开户。',
        min18: '18岁以下用户暂不支持开户',
        errAccount: '身份证剩余有效期小于6个月，请更新证件后申请开户。',
        ywxm: '英文姓名',
        xing: '姓',
        ming: '名',

        sfzsyyxq: '识别失败，请重新上传边框完整、文字清晰的身份证照片。',
        sfzyxqbhf: '身份证有效日期不合法，请重新上传',
        qscsfzjrxm: '请上传身份证人像面',
        qsczfzgh: '请上传身份证国徽面',
        sfzbwz: '身份证不清晰或边框不完整，请重新上传',
        sfzfyj: '非身份证原件或正式身份证，请重新上传',
        sfzfg: '身份证反光，请重新上传',
        qqryxxxyzjwqyz: '请确认以下信息与证件完全一致，避免影响您的开户进度',
        zjhm: '证件号码',
        xmpy: '姓名拼音',
        qzysfdyz: '请注意多音字',
        zzdz: '住宅地址',
        gsfzykhhsqkh: '该身份证已开户或申请开户中，请退出登录后使用原账号登录',
        sjh: '手机号',
        rgnwjyzhdmm: '如果您忘记原账号的密码，可使用手机号找回密码。 如有疑问，请',
        zgdlshs: '上海市',
        changqi: '长期',
        dlsfzzm: 'ZM-内地-身份证-正面',
        dlsfzfm: 'FM-内地-身份证-反面',
        polyphoneWarnText: '您的姓名存在多音，请确认拼写无误，避免影响出入金',
        gender: '性别',
        male: '男',
        female: '女',
    },
    // 开户银行卡
    bankCard: {
        yhkyz: '内地银联银行卡验证',
        yhkyzDesc: '请上传您的香港/澳门或海外证件照片',
        yhkyzDesc1: '内地银行卡仅用于身份核验，不适用于出入金。',
        qsrhsmyhh: '请输入/扫描内地银联银行卡号',
        bankCardNum: '银行卡号',
        qsryhylsjh: '请输入内地银联银行卡预留手机号码',
        phoneNumber: '银行预留手机号',
        yhylsjhmbnwk: '银行预留手机号不能为空',
        qsrnddzyxdz: '请输入您的电子邮箱地址',
        emailAddress: '电子邮箱地址',
        jdjsfs: '结单寄送方式',
        email: '电子邮件',
        jdyy: '结单语言',
        ftzw: '繁体中文',
        dzyxyyjsjddzqywdyjtz: '电子邮箱用于接收结单等业务的邮件通知，请确认无误',
        dzyx: '电子邮箱',
        qsrzqddzyxdz: '请输入正确的电子邮箱地址',
        dlkhyhk: '内地-开户银行卡',
        yhksbcw: '认证失败，请更换手机号码或银行卡重新验证',
        bankOcrError: '银行卡识别失败',
    },
    // 开户-职业状况
    jobStatus: {
        xxhyx: '小学或以下',
        zhongxue: '中学',
        ykhzsxy: '预科或专上学院',
        dx: '大学',
        sshys: '硕士或以上',
        sg: '受雇',
        zg: '自雇',
        tx: '退休',
        xs: '学生',
        wy: '无业',
        nlmy: '农林牧渔',
        nlmyy: '农、林、牧、渔业',
        gyjz: '工业/建筑',
        cky: '采矿业',
        zzy: '制造业',
        jzy: '建筑业',
        dlrlrqjsqschgy: '电力、热力、燃气及水生产和供应业',
        jrsy: '金融/商业',
        jry: '金融业',
        fdcy: '房地产业',
        pfhlsy: '批发和零售业',
        zlhsfwy: '租赁和商务服务业',
        zshcyy: '住宿和餐饮业',
        xxjskx: '信息技术/科学',
        xxcsrjxx: '信息传输、软件和信息技术服务业',
        kxyjhjsfw: '科学研究和技术服务业',
        ggshjt: '公共/社会/交通',
        jtyscchyz: '交通运输、仓储和邮政业',
        jy: '教育',
        slhjhggssgly: '水利、环境和公共设施管理业',
        wshshgz: '卫生和社会工作',
        whtyyl: '文化、体育和娱乐业',
        ggglhshbz: '公共管理、社会保障和社会组织',
        jmfwxlother: '居民服务、修理和其他服务业',
        guoji: '国际',
        guojizuzhi: '国际组织',
        gaoguan: '高管',
        zhongceng: '中层',
        chujiguanli: '初级管理人员',
        putongyuangong: '普通员工',
        hehuoren: '合伙人',
        faren: '法人',
        zongjinli: '总经理',
        shaoyuyinian: '少于1年',
        yidaoliangnian: '1-2年',
        sandaowunian: '3-5年',
        liudaojiunian: '6-9年',
        shinianyishang: '10年及以上',
        jiating: '家庭',
        jianzhixinjin: '兼职薪金',
        zujin: '租金',
        tuixiujin: '退休金',
        fdctzsy: '房地产投资收益',
        jrsctzsy: '金融市场投资收益',
        qtlwbc: '其他劳务报酬',
        zyzk: '职业状况',
        zyzkDesc: '根据监管要求收集以下信息。',
        qxzzgxl: '请选择最高学历',
        zgxl: '最高学历',
        qxzzyzt: '请选择职业状态',
        zyzt: '职业状态',
        selectGs: '请选择公司',
        qsrgswzmc: '请输入公司名称',
        qsrgsWZmcPlaceholder: '请输入公司完整名称',
        gsmc: '公司名称',
        qsrbgsdzxx: '请输入办公室地址信息',
        bgsdz: '办公室地址',
        qxzhy: '请选择公司行业',
        hangye: '公司行业',
        qxzzy: '请选择职位',
        zhiwei: '职位',
        qxzgznq: '请选择工作年期',
        gznq: '工作年期',
        tzzjlydx: '投资资金来源',
        cwzk: '债务状况',
        wzw: '无债务',
        fd: '房贷',
        qtzw: '其他债务',
        brwzwjf: '本人无债务纠纷',
        yzwjfzbzckh: '有债务纠纷，请联系客服进行线下开户。',
        xzhy: '选择行业',
        ylj: '已了解',
        xxBefor: '最高学历为小学或以下请',
        xxAfter: '进行线下开户。',
        lxkf: '联系客服。',

        inputCompanyInfo: '填写公司信息',
        SamePrompt: '办公室地址与公司名称重复，请重新输入',
        CompanyAddressTip: '请完整填写xx市xx区xx街道xx楼栋xx楼层xx室',
    },
    // 开户-财务状况
    Finance: {
        zyzkDesc: '根据监管要求收集以下信息。',
        xjywsr: '薪金/业务收入',
        grcx: '个人储蓄',
        zcjc: '资产继承',
        tzsy: '投资收益',
        zczs: '资产转售',
        '20wanyixia': '20万以下',
        '20wandao50wan': '20万-50万',
        '50wandao100wan': '50万-100万',
        '100wandao500wan': '100万-500万',
        '500wandao1000wan': '500万-1000万',
        '1000wanyishang': '1000万以上',
        '100wanyixia': '100万以下',
        // v2 净资产/可投资金额选项（与风险测评一致）
        '250wanyixia': '250万以下',
        '250wandao500wan': '250万-500万',
        '500wandao800wan': '500万-800万',
        '800wandao1500wan': '800万-1500万',
        '1500wandao4000wan': '1500万-4000万',
        '4000wandao8000wan': '4000万-8000万',
        '8000wanyishang': '8000万以上',
        '500wandao700wan': '500万-700万',
        '700wandao1000wan': '700万-1000万',
        '100wandao300wan': '100万-300万',
        '300wandao500wan': '300万-500万',
        cwzk: '财务状况',
        zjly: '投资资金来源',
        qxzqnsr: '请选择全年收入(港元)',
        qnsr: '全年收入(港元)',
        qxzjzc: '请选择净资产(港元)',
        jzc: '净资产(港元)',
        qxzkyztzdldzc: '请选择可投资金额(港元)',
        kyztzdldzcjz: '可投资金额(港元)',
        qxzmnpjtzje: '请选择每年平均投资金额(港元)',
        mnpjtzje: '每年平均投资金额(港元)',
        zzlb: '住宅类别',
        jzcbysykytzdldzc: '净资产不应少于可投资金额。',
        lxkf: '联系客服。',
        sushe: '宿舍',
        yjrtz: '与家人同住',
        zufang: '租房',
        anjiewuye: '按揭物业',
        zizhiwuye: '自置物业（无按揭）',
        zigui: '自雇',
        shougu: '受雇',
        wuzhaiwu: '无债务',
    },
    // 开户-投资经验
    Investment: {
        ynyx: '1年以下',
        yzhiwunian: '1-5年',
        liuzhishinian: '6-10年',
        shinianyishang: '10年以上',
        baoben: '保本',
        zczz: '资产增值',
        gxhb: '股息回报',
        duichong: '对冲',
        tl: '套利',
        touji: '投机',
        wyyjxyspmm: '我有意进行衍生品买卖',
        wwyjxyspmm: '我无意进行衍生品买卖',
        jrjgjbdyspjz: '金融机构举办的衍生品讲座。',
        jyjgjbyspwskc: '教育机构举办衍生品网上课程或教室课程。',
        yhxtgs: '银行/信托公司',
        zqqhqq: '证券/期货/期权',
        jjzgjz: '基金/资管公司/家族办公室',
        jysjrhyxh: '交易所/金融行业协会',
        bxgs: '保险公司',
        ysqz: '衍生权证',
        nxz: '牛熊证',
        qhhqq: '期货和期权',
        gpggpj: '股票挂钩票据',
        yq: '远期',
        dqhh: '掉期（互换）',
        tzjy: '投资经验',
        gptzjy: '香港上市股票投资经验',
        jytzjy: '金银投资经验',
        whjsptzjy: '外汇及商品投资经验',
        agtzjy: 'A股投资经验',
        jjtzjy: '基金投资经验',
        tzmddx: '投资目的',
        khxys: '客户协议书',
        wyjxyspmm: '无意进行衍生品买卖',
        yyjxyspmm: '有意进行衍生品买卖',
    },
    Derivative: {
        yspmm: '衍生品买卖？',
        nsfljyscpdzytcjfx: '您是否了解衍生产品的主要特征及风险',
        wmbybyscpdzytzqlj: '我明白一般衍生产品的主要特征。且了解衍生产品的主要特征以及衍生交易中所涉及的风险。',
        nxyzsyyyxyscpxgjy: '您需要至少拥有一项衍生产品相关经验（多选）',
        wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有关介绍衍生产品之性质及风险的培训或课程。',
        wxshgwdgzjyywyyscpyg: '我现时或过往的工作经验/业务与衍生产品有关。',
        wxshgwdgzjyywyyscpygyqxgzy: '我现时或过往的工作经验/业务与衍生产品有关。与其相关职业和性质为：',
        wxshgwdyyscpygdgzjyywdfwnqw: '我现时或过往的与衍生产品有关的工作经验/业务的服务年期为：',
        wymmyscpdjymmgdyscps: '我有买卖衍生产品的经验。买卖过的衍生产品是：',
        yscpbkdbxyysqcnxzgpzsqh:
            '衍生产品包括但不限于衍生权证、牛熊证、股票/指数期货及期权、商品结构性产品及交易所基金等，无论是否于交易所进行交易。',
        nyqrwytzyscpbckh: '您已确认无意投资衍生产品，本次开户将不会开通衍生品交易权限。',
    },
    selectAccount: {
        xzzh: '选择账户',
        zqzhlx: '证券账户类型',
        jinjinzh: '理财账户',
        shichangleixing: '市场类型',
        yiliaojie: '已了解',
        xinjinzhanghu: '现金账户：',
        sybrzyzjjxjy: '使用本人自有资金进行现金交易，不允许借贷融资，不允许卖空股票。',
        rzzh: '保证金账户：',
        ycbzjzhhmzzh: '亦称融资账户或孖展账户。除可使用自有资金交易，亦可使用融资交易功能。',
        rongzi: '融资',
        sztggzhxfxhljr:
            '是指通过该账户向复星国际证券借入资金进行买入股票，起到放大交易杠杆的作用。可放大收益率，但也会放大风险。请根据自身风险承受能力选择账户类型。',
        ktlczhh: '开通理财账户后，您可以购买场外基金、场外债券产品；若不开通理财账户，则无法购买上述产品',
        rzzhanghu: '保证金账户',
        xianjinzhanghu: '现金账户',
        tradeClasses: '交易品种',
        ganggu: '港股',
        meigu: '美股',
        hushengangtong: 'A股通',
        qixian: '期权',
        licai: '理财',
        zbkxzsclx: '暂不可选择市场类型',
        btxbkqx: '必选项不可取消',
        noSelectOpenFund: '暂不可取消选择理财账户',
        CashAccountTip: '使用本人自有资金进行交易，不允许借贷融资。',
        MarginAccountTip: '亦称融资账户或孖展账户。除可使用自有资金进行交易，亦可使用杠杆融资交易功能。',
        selectAccountToast: '请选择证券账户类型',
        viewMore: '查看更多',
        marginAccountDesc1: '又称【融资账户】或【孖展账户】，允许客户以股票作为抵押，借用证券公司资金进行融资交易',
        marginAccountDesc2: '支持交易多市场股票、<span class="bold">美股期权</span>、基金、债券',
        cashAccountDesc1: '仅可使用自有资金交易',
        cashAccountDesc2: '支持交易多市场股票、基金、债券',
        recommend: '推荐',
        noDerivative: '您暂未开通衍生品权限，无法开通期权品类，请返回投资问卷页面进行开通',
        zbzcqx: '港美A股默认开通，暂不支持取消',
        zbzcqxCn: '港美股默认开通，暂不支持取消',
        derivativeRole: '衍生品权限',
        derivativeNoOpen: '已开通',
        derivativeNoOpenTips: '期权市场需要开通衍生品权限',
        derivativeOpenTips: '期权市场需要开通衍生品权限，不开通则无法进行期权交易',
        derivativeOpenSuccess: '已开通衍生品权限',
        derivativeNoOpenError: '未开通衍生品权限，无法开通期权市场',
    },

    disclosure: {
        brdpoffxhlzq: '本人的配偶非复星国际证券有限公司的保证金客户。',
        brhbrdpowygtkg: '本人或与本人的配偶未有共同控制任何复星国际证券有限公司的公司保证金客户35%或以上之投票权。',
        brbdblyfxzq: '本人不代表另一复星国际证券有限公司的保证金账户行事。',
        brbmyyfxhl: '本人并没有与复星国际证券有限公司的另一保证金客户代表同一第三方行事。',
        brbsfxhldsysyr:
            '本人不是复星国际证券有限公司任何其他保证金账户的实益拥有人，或不会从复星国际证券有限公司任何其他保证金账户的交易中取得商业或经济利益或承担商业或经济风险。',
        brmyxfxhllykhdb: '本人没有向复星国际证券有限公司的另一保证金客户提供担保或收取担保。',
        brbmyyfxhllykhdbfz: '本人并没有与复星国际证券有限公司的另一保证金客户由同一担保人担保财务负债。',
        brwbzhzzsyr: '本人为本账户的最终实益拥有人。',
        brhbzhdzzsyrwfzqcpr: '本人或本账号的最终实益拥有人非根据香港《证券及期货条例》登记的持牌法团或注册机构之持牌代表或雇员。',
        bryfxhlcprmyqqgx: '本人与复星国际证券有限公司的持牌代表或雇员并没有亲戚关系。',
        brhbrdygrsmycz:
            '本人或本人的“有关联人士”（包括有关本人的未成年子女的账户及有关本人拥有实益权益的账户）于复星国际证券有限公司并没有操作/持有其他賬戶。',
        brjpobbszygz:
            '本人及/或本人的配偶、合伙人、子女、父母或近亲并不是现时/曾经于政府或国际组织被赋予任何重要公职，例如国家或政府元首，高级政治家/高级政府官员，高级行政人员或上述人士的家人或有密切连络人士（定义详见《打击洗钱及恐怖分子资金筹集（金融机构）条例》）',
        brbsmgjm: '本人不是美国居民、公民或未持有美国永久居民身份证（绿卡）。',
        sfpl: '身份披露',
        rldsfyxxbyz: '如您的身份与选项不一致，请联系客服进行线下开户。',
        yynymgsfzbzswfkh: '如您为美国人身份，请联系客服进行线下开户。',
        yes: '是',
        no: '否',

        AML_title: '反洗钱风险提示',
        AML_des: '由于您的名字与某些洗钱案例名字吻合，因此，请您仔细阅读后并确认以下问题。',
        AML_pop1: '本人未曾经涉及违法或违反监管守则而被捕/受审/被判刑/被纪律处分',
        AML_pop2: '本人不存在 (或可能涉及) 任何诉讼 (民事和刑事)、仲裁、政府处罚、政府调查或任何其他争议',
        AML_pop3:
            '本人或本人的直系亲属不是现时/曾出任有关之政府公职(包括：国家或政府元首、重要政客、高级政府官员、高级司法官员、高级军方官员、重要政党的干事、国有企业高级行政人员或宗教领袖) 或国际组织政治人物? 更详细定义见《打击洗钱及恐怖分子资金筹集(金融机构)条例》',
        AML_tips: '若不满足选项条件，请联系客服进行线下开户。',

        AML_que1: '您或您的直系亲属是否曾为国家/政府机关及事业单位高级公职人员?',
        AML_que2: '您是否曾涉及金融监管机构(如:人民银行，证监会，保监会，银监会)的调查或处罚?',
        AML_que3: '您是否曾涉及洗钱、金融犯罪、资助恐怖主义或其他非法活动(刑事)而被调查/起诉/定罪?',
        AML_que4: '您是否曾被任何政府机构、监管机构、或国际组织列入制裁名单?',
        AML_que_tips: '若不满足选项条件，请联系客服进行线下开户。',
        AML_desc_error: '详细描述不能为空',
        AML_desc_placeholder: '请补充详细描述',
    },
    TaxInfo: {
        shuwuxinxi: '税务信息',
        shuwuxinxi_des:
            '根据国际通用的《共同申报准则》(CRS)规定，我们需要收集您的税务国家/地区及税务编号，这些信息可能会与您税务国家/地区的税务机关共享，仅用于税务申报用途。',
        sbshenfen: '申报税务身份',
        shuwudiqu: '税务地区',
        shanchu: '删除',
        qxzgjhdq: '请选择税务国家/地区',
        swgjdq: '税务国家/地区',
        qsrswbh: '请输入税务编号',
        swbh: '税务编号',
        tjxswxx: '添加新税务信息',
        xinxi: '信息',
        qxzw8gjdq: '请选择W-8BEN国家/地区',
        w8gjdq: 'W-8BEN国家/地区',
        gjdq: '国家/地区',
        qsryjjzdz: '请输入永久居住地址',
        yjjzdz: '永久居住地址',
        yiliaojie: '已了解',
        brsmbrwxlsfzswjm: '本人声明本人为下列司法管辖区之税务居民。',
        qtxnwswjmssdsygx:
            '请填写您为税务居民所属的所有司法管辖区及相应的税务编号（香港包括在内）。如果您对您的税务居民司法管辖区有任何疑问，请联络您的税务顾问。',
        rnsxgjm: '如你是香港税务居民，税务编号是香港身份证号码。如你是中国税务居民，税务编号是中国公民身份证号码。',
        xmknwnzdtr: '下面可能已为你自动填入相关信息，如与实际情况不符，请你重新填写。',
        qhdywzzdzzktxywpy: '请核对英文住宅地址 ，只可填写英文/拼音。',
        zgnd: '中国内地',
        qrscgtswxxm: '确定删除该条税务信息吗？',
        swbhcf: '税务编号重复，请重新填写',
        swgdcf: '税务国家/地区重复，请重新选择',
        qtxnwyjjmssdswsfgxqjswbh: '请填写您为永久居民所属的税务司法管辖区及税务编号',
        hkfyzbshsc: '香港非永居用户不能删除税务信息',
        yndswxxjbsbzhxgjsj: '您的税务信息将被申报至香港税局',
        qsrpy: '不允许输入汉字',
        upTitle: '上传文件证明',
    },
    W8popTipText: 'W8国家需在国籍或税务所属国家中选择，永久居住地址与住宅地址一致。若有疑问，请',
    填写须知: '填写须知',
    understand: '已了解',
    Country: {
        qsrdqgjzss: '请输入地区关键字搜索',
        cydq: '常用地区',
    },
    riskDisclosure: {
        fengxianpilu: '风险披露',
        wqcmbgpjgzd: '我清楚明白"股票价格涨跌，买卖证券均可带来亏损或盈利"；',
        wqcmbkhxyzxcddzjyfx: '我已清楚明白客户需要自行承担电子交易带来的风险及损失；',
        wyqcmbmgddjg: '我已清楚明白美股及其他海外证券受当地证监会监管，而非香港证监会监管。',
        nbxwztwfxyp: '您必须完整听完风险披露音频才能继续开户',
        ypjzz: '音频加载中',
        图片加载中: '图片加载中',
        yy: '粤语',
        putonghua: '普通话',
        wyjydjmb: '我已经阅读及明白',
        khxys: '客户协议书',
        nr: '内容；',
        cpdb: '持牌代表：',
        pzh: '牌照号',
        bs: '倍速',
        yue: '约',
        fen: '分',
        miao: '秒',
        请点击下方播放按钮听取完整风险披露音频: '请点击下方播放按钮听取完整风险披露音频',
        复星国际证券请您仔细阅读风险披露: '复星国际证券请您仔细阅读风险披露',
        riskTitle: '风险披露内容',
        riskCheck: '本人已经详细了解、清楚明白、完全接受并同意遵守以上披露内容',
        riskIntro: '您好，我是{name}，持有香港证监会发出的证券交易牌照，中央编号是{license}。',
        riskIntro2:
            '在您的证券户口开通之前，请您仔细阅读客户协议书和风险披露声明书，如果对以上两份资料有任何疑问，请与我们联络，我们会尽快为您解答有关的问题。',
        riskIntro3: '请您留意风险声明中以下几个要点。',
        riskContent1: '1. 投资涉及风险，股票价格可升可跌，买卖证券均有可能带来损失或盈利。',
        riskContent2: '2. 如果当您要进行衍生品的交易，例如牛熊证、认股权证等，已知悉其附带的风险更大，价格有机会跌至为零。',
        riskContent3: '3. 已清楚客户需自行承担电子交易带来的相关风险及损失。',
        riskContent4: '4. 如果您有意买卖美股或其他海外证券，已清楚美股或其他海外证券受当地证监会监管，而非香港证监会监管。',
        riskEnd: '最后，您同意并接受复星国际证券的客户协议书和风险披露说明书，请您在相关项目下面打勾，谢谢您。',

        riskOptionIntro:
            '尊敬的客户，您好，我是复星国际证券有限公司的{name}，持有香港证监会发出的证券交易牌照，中央编号是{license}。在您的证券或美股期权账户开通之前，请您仔细阅读客户协议书和风险声明披露文件，若有疑问，请与我们联络，我们会尽快为您解答有关的问题。以下我会简单为您说明买卖证券及美股期权风险声明中的几个要点。',
        riskOptionContent1:
            '第一，投资涉及风险，股票价格可升可跌，买卖证券均有可能带来损失或盈利。而美股期权交易具有高风险性，您可能蒙受的亏损会超过初始投资金额，甚至可能需要追加保证金。若未能及时存入，您的未平仓合约可能被强制平仓，但您仍需对账户内的任何亏损负责。',
        riskOptionContent2:
            '第二，进行衍生品的交易都具有时间损耗的风险，假若其他情况不变，衍生权证随着到期日临近，衍生权证的时间价值会逐渐减少，可能导致期权价值大幅下降甚至归零。衍生产品亦都可能涉及杠杆的元素，虽然可能放大收益，但也可能放大亏损，甚至可能导致损失超过初始投资金额。',
        riskOptionContent3:
            '第三，流动性风险和执行风险也需注意。在某些市场情况下，期权合约可能因流通量不足而难以在理想价格买入或卖出。若您选择行使期权，还可能面临标的资产无法及时交割或结算的风险。',
        riskOptionContent4:
            '第四，如果投资在受外国法律管辖的任何资产或投资是由受外国法律管辖的一方发行，可能涉及额外风险，且您所在地的监管机构可能无法强制执行其他地区的规则。因此，建议您在交易前详细了解相关市场的规则，并咨询专业顾问。',
        riskOptionEnd1: '最后，客户需自行承担电子交易带来的相关风险及损失。',
        riskOptionEnd2:
            '在您开立证券交易账户或美股期权交易账户前，请务必仔细阅读并完全理解本风险披露声明的全部内容。证券投资及美股期权交易均涉及风险，请您根据自身的投资经验，财务状况，投资目标及风险承受能力，审慎考虑是否适合进行相关投资。更详细的披露，请详阅美股期权交易的披露文件。若您有任何疑问，欢迎随时联系我们。',
        riskOptionEnd3: '感谢您的聆听，祝您投资顺利！',
    },
    SignAgreement: {
        qianshuxieyi: '签署协议',
        wyydqb: '我已阅读全部',
        khwj: '开户文件',
        yljxgfxbzy: '，了解了相关风险并自愿在复星国际证券开户',
        dianjiqianming: '点击签名',
        wqrystgdbrsyzljwzsyx:
            '我确认以上提供的本人的所有资料和文件均为有效，真实，完整，准确及最新，且我授权复星国际证券从其认为合适的来源验证该等资料。我进一步同意如该等资料有任何变更会从速以书面形式通知复星国际证券。我确认，复星国际证券有权根据其认为恰当的任何资料来源以更新其现存的资料。如有需要复星国际证券可要求我确认有关资料。',
        swzwzm: '税务自我证明声明',
        khxys: '客户协议书',
        gryxtk: '个人资料(私隐)条款',
        yhdlxy: '用户登录协议',
        bzjzhcssqxy: '保证金账户常设授权协议书',
        mpgqjyxy: '美股期权交易协议',
        mghqshm: '美股及美股期权行情声明协议',
        khsmjqr: '客户声明及确认',
        fybz: '费用标准',
        tbkhfxplsm: '特别客户-风险披露声明',
        yiqueren: '已确认',
        yProtocol1: '我已阅读',
        yProtocol2: '《资产转移确认声明》',
        yProtocol3: ', 同意将云锋证券资产转移至复星国际证券',
        yProtocolTips: '如您不同意勾选《资产转移确认声明》，开户成功后您需于app提交线上转仓申请。',
        goonSign: '继续签名',
        pageTitle: '复星国际证券',
        dzqmf: '电子签名法',
        wzsm: '伪证声明',
        taxInfoAgreement: '税务信息与预扣税协议',
    },
    Signature: {
        qzfknhxqsndmz: '请在<span style="color: #ff6907;">方框内</span>横向签署你的名字：',
        chongxie: '重写',
        wancheng: '完成',
        kehuqianming: '客户签名',
    },
    LivingWitness: {
        rlyz: '人脸验证',
        qasldzpsydsmbrmbsp: '请按示例动作拍摄一段3秒的本人面部视频',
        shili: '示例',
        banshenzhengmian: '半身正面视频',
        paishetishi: '拍摄提示',
        qbzmbwz: '请确保脸部完整，保持光线充足；',
        spschrbmykcxps: '视频上传后，若不满意可点击重新拍摄',
        dqllqbbbzcsxtqqhllq: '当前浏览器版本不支持摄像头，请切换浏览器',
        yzsbqcxyz: '验证失败，请重新验证',
        lzspsbqcxlz: '录制视频失败，请重新录制',
        qzydddkym: '请在移动端打开页面',
        rlyztg: '人脸验证通过',
        spwjgdqcxsc: '视频文件过大，请重新上传',
        htsbtp: '活体识别图片',
        videoShortMsg: '视频过短，请重新上传',
        videoLongMsg: '视频过长，请重新上传',
        uploadSuccessMsg: '上传成功',
        yuji: '预计',
        status_calculating: '正在计算文件校验码...',
        status_init: '初始化',
        status_uploading: '正在上传...',
        status_completing: '正在处理文件...',
        status_done: '上传完成',
        status_verifying: '认证中',
    },
    CaApply: {
        zssq: '证书申请',
        zlyjtxwbdjljck: '资料已经填写完毕，点击链接查看开户书',
        wqrsq: '我已阅读并同意',
        confirmAfterText: '确认申请粤港互认电子证书，申请成功后同意使用证书签署开户书',
        grkhsqb: '个人开户申请表',
        zwzmbg: '自我证明表格（个人）',
        pdfwjz: 'pdf文件未加载',
        rvckwjqdjysjzllqdk: '如需查看文件，请点击右上角在浏览器中打开',
        wjjzz: '文件加载中',
        wjjzsb: '文件加载失败',
    },
    OpenStatus: {
        ryyw: '如有疑问，请',
        bhyy: '驳回原因',
        sm: '说明',
        xingming: '姓名：',
        henglihao: '星财号：',
        lianxikefu: '联系客服',
        khzlshz: '开户资料审核中',
        khzltbz: '开户资料同步中',
        yjydlrkt: '我们正在加速审核，预计1-2个工作日内审核完毕',
        zlshbtgDesc: '请修改或确认信息以继续完成开户',
        khcgDesc: '感谢您的信任，让我们一起开启财富之旅',
        age65To75Tip: '您的开户申请已提交，若资料审核无误，1个工作日内会有客服专员电话联系您确认信息，请留意接听。',
        zlshbtg: '审核不通过',
        bckhzl: '补充开户资料',
        bczl: '补充资料',
        khcg: '开户成功',
        gxkhcg: '恭喜您开户成功！',
        crzj: '存入资金',
        khsqytj: '开户申请已提交',
        khqqtjsb: '开户请求提交失败',
        lymcppsbl: '路由名称匹配失败了',
        shz: '审核中',
        bh: '驳回',
        wc: '完成',
        redirecting: '跳转中',
    },
    home: {
        selectOpenAccountType: '请选择开户类型',
        hkTitle: '网上转账开户',
        hkSubtitle: '香港银行账户转账一万港币',
        planFile: '请准备以下材料',
        PHK_IdcardFile: '海外居民请提供护照，港澳居民请提供身份证或护照',
        PHK_HZFile: '非内地护照/身份证',
        PHK_AddressFileDesc: '由指定机构提供的，包括您的姓名和地址的文件',
        PHK_AddressFile: '有效期3个月内的地址证明',
        PHK_money: '香港银行账户',
        PHK_moneyDesc: '通过同名香港银行账户，转账至复星国际证券以作开户认证，单笔入金金额不少于等值 10,000 港元',

        cnTitle: 'CA见证开户',
        cnSubtitle: '拥有海外身份证件的内地籍人士',
        PCN_HK: '非内地身份证件',
        PCN_HKDesc: '香港、澳门或其他海外身份证件',
        PCN_IdCard: '中国内地居民身份证',
        PCN_IdCardDesc: '有效期大于6个月，且已年满18周岁',
        PCN_BankCard: '中国内地银行卡',
        PCN_BankCardDesc: '仅用于身份核验，不适用于出入金',
        No_OpenCnAccount: '非常抱歉，目前无法为中国境内投资者提供开户服务。',

        bryydtykt: '本人同意开通',
        dzjyfw: '电子交易服务',
        bryydbty: '本人已阅读并同意',
        khxys: '客户协议书',
        xyb: '下一步',
        qh: '切换',
        changeCN: '中国内地居民身份证开户',
        changeHW: '香港/澳门居民身份证及护照（非内地）开户',
        changeCnOrHwBefor: ',当前的开户申请将会失效，确认继续吗？',
        khsqtjsb: '开户申请提交失败',
        changeOpenAccount: '切换开户方式',
    },
    Step: {
        xxyz: '信息验证',
        fxpl: '风险披露',
        rlyz: '人脸验证',
        rjrz: '入金认证',
    },
    UploadFile: {
        scz: '上传中...',
        jzz: '加载中...',
        scsbqcs: '上传失败，请重试',
        xztp: '选择图片',
    },
    fxhlkh: '复星国际证券开户',
    AccountStatus: {
        xingming: '姓名：',
        henglihao: '星财号：',
        bhyy: '驳回原因',
        lcjd: '流程节点',
        khzlshz: '开户资料审核中',
        khzlxg: '开户资料',
        btg: '不通过',
        zlshytg: '资料审核',
        ytg: '已通过',
        ljxg: '立即修改',
        crzj: '存入资金',
        bckhzl: '补充开户资料',
        zjdzqrz: '资金到账确认中',
        zjdzyc: '资金到账',
        yc: '失败',
        zjydz: '资金到账',
        ydz: '已确认',
        jxcrzj: '继续存入资金',
        zrgp: '转入股票',
        lxkf: '联系客服',
        yjydlrkt: '我们正在加速审核，预计1-2个工作日内审核完毕',
        qqrhxgqrxxyjxwckh: '请修改或确认信息以继续完成开户',
        khcg: '开户成功',
        zwrjqtjrj: '暂未入金，请提交入金',
        ljrj: '立即入金',
        zcsqqrz: '转仓申请确认中',
    },
    hk_IDcard: {
        xgjmsfz: '香港居民身份证',
        amjmsfz: '澳门居民身份证',
        huzhao: '护照（非内地）',
        man: '男',
        woman: '女',
        sfxxyz: '信息验证',
        sfxxjyykh: '身份信息仅用于开户，我们将严格保护您的个人隐私',
        guojidiqu: '国籍(地区)',
        brssxgdyjjm: '本人是所选国籍(地区)的永久居民',
        yjjum: '您当前是否为香港/澳门或海外永久居民',
        khvjxx: '开户证件信息',
        khtips: '提示：港澳通行证不可作为开户证件',
        txyjxx: '请填写您的香港/澳门或海外永居证件信息',
        txfyjxx: '请填写您的香港/澳门或海外非永居证件信息',
        qxzgjdq: '请选择国籍(地区)',
        zjlx: '证件类型',
        qxzzjlx: '请选择证件类型',
        qfgjdq: '签发国家/地区',
        qxzqfgjdq: '请选择签发国家/地区',
        zjhm: '证件号码',
        qsrzjhm: '请输入证件号码',
        szhzm: '数字或字母',
        xgjmsfzwxsrkh: '香港居民身份证无须输入括号，例:A1234567',
        证件号码格式错误: '证件号码格式错误',
        qsrzjhm: '请输入证件号码',
        scsfz: '上传证件',
        qscjmsfz: '点击上传 居民身份证/护照人像面',
        djshchid: '点击上传 居民身份证人像面',
        djshchrxm: '点击上传 护照人像面',
        yjinfo: '永居证件信息',
        qscyjzjxx: '请填写您的永居证件信息',
        qscsfzjrxm: '请上传身份证件人像面，中国内地身份证需同时上传人像面和国徽面',
        MO_qscsfzjrxm: '请上传身份证件人像面，中国内地身份证与澳门居民身份证需同时上传人像面和徽章面',
        yjxxtsh: '上传所选国籍(地区)永居居民身份证件或护照',
        zgxg: '中国香港',
        zgam: '中国澳门',
        gsfzykhhsqkhz: '该身份证已开户或申请开户中，请退出登录后使用原账号登录。',
        sjh: '手机号',
        rgnwjyzhdmm: '如果您忘记原账号的密码，可使用手机号找回密码。 如有疑问，请',
        tjxxsb: '提交信息失败',
        qxxzgqdq: '请先选择国籍(地区)',
        sxgj: '所选国籍(地区)请',
        jxxxkh: '进行线下开户。',
        chIdCard: '身份证',
        chPassport: '中国护照',
        chPassportError: '中国护照格式错误',
    },
    hk_ProofAddress: {
        dzzm: '地址证明',
        dzzmlxbksdtzd: '地址证明类型包括水电通知单、电信、信用卡对账单等',
        jzgjdq: '居住国家/地区',
        qxzjzgjdq: '请选择居住国家/地区',
        jzcs: '居住城市',
        qtxjzcs: '请填写居住城市',
        xxdz: '详细地址',
        qtxxxdz: '请填写详细地址',
        qwztxjdldlc: '请完整填写xx街道xx楼栋xx楼层xx房，与地址证明相同',
        zzdzytxdzxt: '住宅地址与通讯地址相同',
        rzzdzytxdzbt: '如住宅地址与通讯地址不同，请联系我们进行线下开户。',
        scdzzm: '上传地址证明',
        scsl: '上传示例',
        dzzmyxqzsgyn: '地址证明有效期在三个月以内；',
        grxmrqjdzxxxwz: '个人姓名、日期及地址信息需完整；',
        scyjdzb: '上传原件电子版、照片或扫描件；',
        qwscpsddnpmzp: '请勿上传拍摄的电脑屏幕照片；请确保地址证明文件完整，勿进行裁剪。',
        qscdzzm: '点击上传地址证明',
        qqrndzzdzydzzmwqyz: '请确认您的住宅地址与地址证明完全一致，避免影响您的开户进度。',
        zzdz: '住宅地址：',
    },
    hk_UserInfo: {
        grxxtx: '个人信息填写',
        sfxxjyykh: '身份信息仅用于开户，我们将严格保护您的个人隐私。',
        qsrxm: '请输入中文姓名',
        ywxm: '英文姓名',
        xm: '中文姓名',
        xing: '请输入英文姓',
        ming: '请输入英文名',
        xingbie: '性别',
        csrq: '出生日期',
        csdd: '出生地点',
        qxzxb: '请选择性别',
        qxzcsrq: '请选择出生日期',
        qxzcsdd: '请选择出生地点',
        qsrnddzyxdz: '请输入您的电子邮箱地址',
        dzyxdz: '电子邮箱地址',
        jdjsfs: '结单寄送方式',
        dzyj: '电子邮件',
        jdyy: '结单语言',
        xzcsd: '选择出生地',
        ylj: '已了解',
        lxkf: '联系客服。',
        zgdlshs: '上海市',
        qsrzqddzyxdz: '请输入正确的电子邮箱地址',
        man: '男',
        woman: '女',
        s8syxzbzc: '18岁以下用户暂不支持开户',
        l5syszbzc: '76岁或以上用户暂不支持开户',
        ftzw: '繁体中文',
    },
    transitionGold: {
        dqjd: '当前进度',
        zlytj1: '资料已提交，存入资金验证身份继续开户',
        zlytj2: '资料已提交，存入资金/转入股票继续完成开户',
        xzrjbz: '选择入金币种',
        zcgymy: '支持港元、美元及离岸人民币入金',
        rjfxhl: '入金至复星国际证券账户',
        db: '单笔',
        zzfxhl: '转至复星国际证券银行账户不得少于等值',
        gangyuan: '港元',
        tzfxhlsk: '通知复星国际证券收款',
        xxzzhxtzfxhl: '线下转账后需通知复星国际证券收款',
        crzj: '存入资金',
        zrgp: '转入股票',
    },
    C_SearchCompany: {
        noSearch: '查不到公司?',
        searchNoData: '暂无搜索结果',
        inputCompanyInfo: '填写公司信息',
    },
    openAccountStrictContent: {
        confirmButtonText: '切换开户方式',
        tip1: '非常抱歉，目前无法为中国境内投资者提供开户服务，您可以通过网上转账开户继续开通证券账户',
        tip2: '非常抱歉，目前无法为中国境内投资者提供开户服务',
        tip3: '温馨提示：切换开户方式，您当前的开户申请将会失效',
        tip4: '请上传身份证人像面，中国境内投资者暂不支持开户',
        tip5: '请前往星财富APP继续完成开户',
        tip6: '请授权使用您当前的位置后再继续进行开户',
        gotoAppBtn: '立即前往',
        gotoSettingBtn: '去设置',
        getAppLocationToastMessage: '获取中...',
    },
    mrStatus: {
        tip: {
            span1: '为提升系统体验，正在进行',
            span2: '系统维护',
            span3: '。开户、出入金、换汇、提交订单等操作将受影响无法使用。同时，系统可能不能正常查询您的资金、持仓、交易历史等，待系统维护后会恢复正常。如对阁下造成不便，为此深表歉意。',
        },
    },
    statement: {
        '抱歉，当前区域为受限制区域，需提供其他香港券商或银行的账户结单才可继续开户。':
            '抱歉，当前区域为受限制区域，需提供其他香港券商或银行的账户结单才可继续开户。',
        现有香港市场账户信息: '现有香港市场账户信息',
        '境内投资者，需提供境外生活或工作证明的文件，方可继续开户。': '境内投资者，需提供境外生活或工作证明的文件，方可继续开户。',
        '开户券商/银行': '开户券商/银行',
        请选择开户券商或银行: '请选择开户券商或银行',
        '其他开户券商/银行': '其他开户券商/银行',
        '请填写其他开户券商/银行名称': '请填写其他开户/银行券商名称',
        开户姓名: '开户姓名',
        请填写开户姓名: '请填写开户姓名',
        账户号码: '账户号码',
        请填写账户号码: '请填写账户号码',
        上传证明文件: '上传证明文件',
        上传图片: '上传图片',
        上传境外工作或生活证明文件: '上传境外工作或生活证明文件',
        '证明文件支持图片、PDF': '证明文件支持图片、PDF',
        结单证明:
            "<span class='blod-txt'>1.结单证明：</span>其他香港券商或香港银行的账户结单，日/月结单的PDF均可。需清晰显示：券商或银行名称、账户姓名、账户号码、账单时间信息。",
        开户证明:
            "<span class='blod-txt'>2.开户证明：</span>其他香港券商或香港银行的开户成功文件或邮件截图。需清晰显示：券商或银行名称、账户姓名、账户号码、账户开通时间或邮件接收时间信息。",
        '证明文件支持图片、PDF，需为6个月以内香港券商/香港银行的完整结单，应包含券商/银行名称及账号信息。':
            '证明文件支持图片、PDF，需为6个月以内香港券商/香港银行的完整结单，应包含券商/银行名称及账号信息。',
        '常用券商/银行名称': '常用券商/银行名称',
        '找不到您要的券商/银行？可添加': '找不到您要的券商/银行？可添加',
        其他: '其他',
        brokerName: '请输入券商/银行名称',
        '当前区域为受限制区域，需提供其他香港券商或香港银行的账户结单才可继续开户。':
            '当前区域为受限制区域，需提供其他香港券商或香港银行的账户结单才可继续开户。',
        结单示例: '结单示例',
        稍后提交: '稍后提交',
        uploadPromise: '本人承诺上传的信息均真实、准确、无任何虚假内容，并愿意承担因提供虚假信息所带来的一切后果',
        proofList: {
            title: '包括但不限于 (必须是境外)',
            list: [
                '雇佣合同',
                '税单/社保缴纳记录',
                '在职证明',
                '租房合同/房产证明',
                '电话费单据',
                '长期居留签证/永居卡',
                '水电煤费账单',
                '工资单/银行流水(工资记录)',
                '驾照/当地身份证',
                '学校录取通知书/在读证明',
                '工作签证/工作许可',
                '其它符合要求证明的文件',
            ],
            '身处香港/海外证明': '身处香港/海外证明',
            开户提交日期必须于获批准逗留期间内: '开户提交日期必须于获批准逗留期间内',
            hkList: ['过关小票', '出入境证明文件'],
        },
        证明文件必须包括: '证明文件必须包括',
        '账单类证明文件，发出日期须在三个月以内': '账单类证明文件，发出日期须在<span class="highlight-txt">三个月以内</span>',
        '证明文件必须包括个人姓名、个人身份证号(如有)、个人地址(如有)、发出时间、发出机构名字':
            '证明文件必须包括个人姓名、个人身份证号(如有)、个人地址(如有)、发出时间、发出机构名字',
        mainlandTitle: '中国内地客户',
        mainlandSubtitle: '需持有香港证件或提供境外工作/生活证明',
        hkDocumentQuestion: '您是否持有香港居民身份证？',
        hkNonPermanentTitle: '香港非永居证件信息',
        uploadHkIdCard: '点击上传香港居民身份证人像面',
        yes: '是',
        no: '否',
        uploadOverseasProof: '上传境外工作或生活证明',
        proofTypeInstruction: '证明类型下选其一',
        proofTypeTitle: '证明类型（提交其一即可）：',
        proofType1: '<span class="blod-txt">1. 金融类：</span>海外电子结单/通知书、海外信用卡账单、工资单（需显示境外公司支付工资的银行流水）',
        proofType2: '<span class="blod-txt">2. 居住类：</span>能源费单据（包括水、电、燃气费单据）、电话费单据、境外房屋租赁证明、境外房屋持有证明',
        proofType3:
            '<span class="blod-txt">3. 官方及其他证明：</span>保险单、税单或其他政府机构出具的单据、香港驾驶证、其他境外国家/地区的驾驶证、劳动/劳务合同、在职证明',
        fileRequirementTitle: '文件要求：',
        fileRequirement1: '证明文件发出日期需在<span class="highlight-txt">三个月以内</span>。',
        fileRequirement2: '需清晰显示您的中文或英文姓名、境外地址信息、证明文件发出日期和发出机构的完整名称。',
        fileRequirement3: '证明文件仅支持图片格式。',
        证明文件示例: '证明文件示例：',

        documentNotAvailable: '证件不在身边？',
        laterSupplement: '稍后补充',
        uploadOverseasID: '请上传您的香港/澳门或海外证件信息',
        fileRequirements: '文件要求',
        uploadDocumentFrontBack: '上传海外证件原件正/反面。',
        supportedFileFormats: '证明文件仅支持图片格式。',
        needHoldOverseasID: '需提供 境外工作或生活的证明',
        photoInstruction: '拍摄时请确保手机横向拍摄，证件边框完整、文字清晰可见、亮度均匀不反光。',
        uploadOverseasIDPhoto: '请上传您的香港/澳门或海外证件照片',
    },
    promptText: '系统识别到当前手机号具备未完成的企业户开户任务，请前往Web版完成企业开户。',

    changeChannel: {
        title: '提交确认',
        confirmButtonText: '确认修改',
        cancelButtonText: '无需修改',
        content1: '当前访问的开户邀请码为',
        content2: '，与您于我司留存的邀请码',
        content3: '不一致，请确认是否修改为最新邀请码',
        content4: '。如有疑问，可联系您的客户经理',
        incorrectChannel: '修改失败，邀请码不存在，请联系客户经理',
    },
    // 信息补充页面
    InformationSupplement: {
        pageTitle: '复星国际证券客服资料复核',
        supplementInfo: '补充信息',
        fundSourceTitle: '资金来源地（多选）',
        tradingFrequencyTitle: '过去一年每月交投次数',
        thirdPartyTransferTitle: '过去一年是否存在第三者汇入/汇出款项？',
        moneyLaunderingTitle: '过去一年是否牵涉关于洗钱的诉讼？',
        spouseAccountTitle: '您的配偶、您自己是否存在与配偶共同操作另一个复星国际证券的账户？',
        fundSourceOptions: {
            hongkong: '香港',
            mainland: '中国内地',
            macau: '澳门',
            singapore: '新加坡',
            usa: '美国',
            canada: '加拿大',
        },
        tradingFrequencyOptions: {
            lessThan1: '少于每月1次',
            '1to10': '每月1-10次',
            '11to20': '每月11-20次',
            moreThan21: '每月≥21次',
        },
        yes: '是',
        no: '否',
        other: '其他',
        prevStep: '上一步',
        confirmNext: '确认无误，下一步',
    },
    BackgroundDisclosure: {
        politicalPersonTitle: '您是否为政治人物或其关联人士？',
        fatfMemberTitle: '您的国籍或居住地区是否属于FATF、APG、CFATF成员国家或地区？',
        highRiskIndustryTitle: '您是否从事涉及大量现金交易或存在洗钱高风险的行业？（如赌场、赌博、货币兑换、汇款代理等）',
        otherRiskFactorsTitle: '您是否存在其他可能被视为高风险的因素？',
        yes: '是',
        no: '否',
    },
}
